import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=e2b377f8&scoped=true"
import script from "./Entity.vue?vue&type=script&lang=js"
export * from "./Entity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b377f8",
  null
  
)

export default component.exports